
import "./ProductRecyclerview.css";


const ProductRecyclerview = ({ items, onItemClick }) => {
      const toggleSection = (imurl) => {
   console.log("imgurl",imurl);
  };
  return (
    <div className="horizontal-recyclerview">
      {items.map((item, index) => (
        <div
          key={index}
          className="recyclerview-item"
          onClick={() => onItemClick?.(item)}
        >
          <img
           src={`${item.images?.[0]}`}

          />

          <h5
            style={{
              fontSize: "13px",
              whiteSpace: "normal",
              wordWrap: "break-word",
            }}
          >
            {item.title}
          </h5>
        </div>
      ))}
    </div>
  );
};

export default ProductRecyclerview;

